import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import config from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import house_icon from "../../assets/images/forgotpass_bg.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { toast } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../utils";
import { postApi } from "../AppApis";
import RestorePasswordSuccess from "../../assets/images/RestorePasswordSuccess.png";
import Brand_icon from "../../assets/images/Brand_icon.png";
const ResetPassword = () => {
    const location = useLocation();
    const data = location.state;
    const [email, setEmail] = useState(data ? data.email : "");
    const [otp, setOtp] = useState(data ? data.otp : "");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [displaySuccessScreen, setDisplaySuccessScreen] = useState(false);
    const [timer, setTimer] = useState(30);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (!data) {
            navigate("/forget-password");
        }
    }, [data]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");

        const emojiRegex = /[\u{1F000}-\u{1FFFF}]|[\u{2600}-\u{27BF}]|[\u{FE00}-\u{FE0F}]|[\u{1F900}-\u{1F9FF}]|[\u{200D}]|[\u{20E3}]|[\u{E0020}-\u{E007F}]/u;
        const passwordRegx = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;
        if (emojiRegex.test(newPassword) || !passwordRegx.test(newPassword)) {
            setValidationError(true);
            setLoading(false);
            return;
        } else {
            setValidationError(false);
        }

        if (newPassword !== confirmPassword) {
            showErrorToast("Passwords don’t match. Please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });

            setLoading(false);
            return;
        }

        const payload = {
            email,
            code: otp,
            new_password: newPassword,
            project_type: "onmls",
        };

        try {
            const response = await fetch(`${config.get("API_URL")}/user/reset-passwd`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data?.detail) {
                return showErrorToast(data?.detail, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }

            showSuccessToast("Password reset successfully!", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            if (data.access_token) {
                setDisplaySuccessScreen(true);
            }
        } catch (error) {
            setMessage(error.message || "Error occurred");
            setMessageType("danger");
        } finally {
            setLoading(false);
        }
    };
    const handleResentOtp = async () => {
        setIsLoading(true);
        try {
            setTimer(30);
            const response = await postApi("/user/forgot-passwd", {
                email: email,
                project_type: "onmls",
            });
            if (response.response && response.response.message) {
                toast.success(response?.response.message);
            } else {
                toast.error("Something went wrong. Please try again");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img src={Brand_icon} alt={`${config.get("COMPANY_NAME")} logo`} className="logo tw-w-[35px] tw-h-[35px]" />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>
                {!displaySuccessScreen ? (
                    <div className="tw-h-full  max-sm:tw-h-fit tw-w-full max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 ">
                        <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center  tw-flex tw-justify-center tw-pt-5  tw-w-full max-sm:tw-mt-10 max-sm:tw-mb-3">
                            <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4  2xl:tw-gap-5 ">
                                <div className="tw-flex tw-flex-col tw-gap-[10px]">
                                    <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px]">
                                        New Password
                                    </h1>
                                    <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                        Set the new password for your account so you can login and access all features.
                                    </p>
                                </div>
                                <div className=" tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                    <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">OTP</span>

                                    <input
                                        type={"number"}
                                        required
                                        value={otp}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 6) {
                                                setOtp(e.target.value);
                                            }
                                        }}
                                        placeholder="Enter Your OTP"
                                        className="tw-px-3 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                    />
                                    <div className="tw-flex tw-justify-end">
                                        <button
                                            type="button"
                                            disabled={timer > 0 || isLoading}
                                            onClick={handleResentOtp}
                                            className="tw-text-primary tw-text-[13px]"
                                        >
                                            {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
                                        </button>
                                    </div>
                                </div>
                                <div className="tw-flex tw-flex-col tw-gap-3 2xl:tw-gap-6">
                                    <div className=" tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Password</span>
                                        <div className="tw-relative ">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                required
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                placeholder="Enter New Password"
                                                className="tw-px-3 tw-pr-12 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px]  tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                            />
                                            {validationError && (
                                                <p className="tw-text-red-600 tw-text-[12px]">
                                                    *Minimum 8 characters, including at least one letter and one number. Emojis are not allowed.
                                                </p>
                                            )}

                                            {/* Toggle Button */}
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                className="tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2"
                                            >
                                                {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Confirm Password</span>
                                        <div className="tw-relative">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                required
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                placeholder="Enter Confirm Password"
                                                className="tw-px-3 tw-pr-12 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                            />

                                            {/* Toggle Button */}
                                            <button
                                                type="button"
                                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                                className="tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2"
                                            >
                                                {showConfirmPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="tw-flex tw-flex-col">
                                    <button
                                        // onClick={handleSubmit}
                                        type="submit"
                                        className="tw tw-bg-primary hover:tw-bg-primary_hover tw-border-none tw-text-white tw-mt-5 tw-p-3 tw-rounded-md"
                                        disabled={loading ? true : false}
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Reset Password"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                ) : (
                    <div className="tw-h-full  max-sm:tw-h-fit tw-w-full max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 ">
                        <div className="tw-flex tw-flex-col tw-gap-4 2xl:tw-gap-5 tw-w-full tw-items-center tw-justify-center">
                            <img
                                src={RestorePasswordSuccess}
                                alt="Restore Password Success"
                                className="tw-w-[200px] tw-h-[200px] tw-object-contain"
                            />
                            <div className="tw-flex tw-flex-col tw-gap-4 2xl:tw-gap-5 tw-w-full tw-items-center tw-justify-center">
                                <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px]">Success</h1>
                                <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-[#52525B] max-sm:tw-font-thin">
                                    Your password has been reset successfully{" "}
                                </p>
                                <button
                                    onClick={() => {
                                        navigate("/login", { replace: true });
                                    }}
                                    className="tw-bg-primary tw-border-none tw-text-white tw-p-3 tw-rounded  tw-px-10   tw-mt-5"
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
